import { MapTo } from '@adobe/aem-react-editable-components';
import { AEM_FUNCTIONS } from '../../common';
// eslint-disable-next-line import/no-named-as-default
import withAsyncImport from '../../utils/withAsyncImport';
import { isTextEmpty } from './helpers';
/**
 * Default Edit configuration for the Text component that interact with the Core Text component and sub-types
 *
 * @type EditConfig
 */
const TextEditConfig = {
    emptyLabel: 'Text',
    isEmpty: isTextEmpty,
};
// lazyload / code splitting example of an internal component
const LazyTextComponent = withAsyncImport(() => import('./Text'));
export default MapTo([AEM_FUNCTIONS.text, AEM_FUNCTIONS.cookieText])(LazyTextComponent, TextEditConfig);
